import { type KeyboardEvent, type MouseEvent, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import loadable from '@loadable/component';

import { Link, LinkVariant } from '@jsmdg/yoshi';

const LoadableRedeemInfoModal = loadable(async () => import('../RedeemInfoModal/RedeemInfoModal'));

const messages = defineMessages({
    redeemInfo: {
        defaultMessage: 'Flexibel einlösbar',
    },
});

const RedeemInfo = (): JSX.Element => {
    const intl = useIntl();
    const [showModal, setShowModal] = useState(false);

    const handleOpenOrClosePopup = (
        event: MouseEvent | KeyboardEvent | undefined,
        shouldShowModal: boolean,
    ) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        setShowModal(shouldShowModal);
    };

    return (
        <>
            <Link
                onClick={(event: MouseEvent) => handleOpenOrClosePopup(event, true)}
                variant={LinkVariant.Grey}
                href={undefined}
                className="d-inline-block mb-0-5x"
            >
                {intl.formatMessage(messages.redeemInfo)}
            </Link>
            {showModal && (
                <LoadableRedeemInfoModal
                    isOpen={showModal}
                    handleOnClose={(event?: MouseEvent | KeyboardEvent) =>
                        handleOpenOrClosePopup(event, false)
                    }
                />
            )}
        </>
    );
};

export { RedeemInfo };
